export default "__VITE_ASSET__BD14lUSM__"